export default function getAuthErrorMessage(error: any) {
  if (error.code === 'UsernameExistsException') {
    return '指定したユーザーIDは既に存在しています。';
  } else if (error.code === 'UserNotFoundException') {
    return '指定したユーザーは存在しません。';
  } else if (error.code === 'NotAuthorizedException' && error.message === 'User is disabled.') {
    return 'このメールアドレスでアクティブなアカウントが存在しません。\n 再度アクティブにしたい場合は管理者の方に問い合わせてください。';
  } else if (error.code === 'NotAuthorizedException') {
    return 'パスワード認証に失敗しました。パスワードをご確認ください。';
  } else if (error.code === 'PasswordResetException') {
    return 'パスワードのリセットが必要です。';
  } else if (error.code === 'PasswordResetRequiredException') {
    //Cognito管理画面にて指定されたユーザーの'パスワードリセットする'をクリックされた場合
    return 'パスワードのリセットが必要です。';
  } else if (error.code === 'UserLambdaValidationException') {
    return '指定したユーザーのログインは許可されていません。';
  } else if (error.code === 'LimitExceededException') {
    return '試行回数を超えました、しばらくしてからお試しください。';
  } else if (error.code === 'AccessDeniedException') {
    return 'このアクションを実行するための十分なアクセス権がありません。';
  } else if (error.code === 'IncompleteSignature') {
    return 'リクエストの署名がAWS標準に準拠していません。';
  } else if (error.code === 'InternalFailure') {
    return '不明なエラー、例外、または失敗が原因で、要求の処理が失敗しました。';
  } else if (error.code === 'InvalidAction') {
    return '要求されたアクションまたは操作は無効です。アクションが正しく入力されていることを確認します。';
  } else if (error.code === 'InvalidClientTokenId') {
    return '提供されたX.509証明書またはAWSアクセスキーIDは、当社のレコードに存在しません。';
  } else if (error.code === 'InvalidParameterCombination') {
    return '一緒に使用してはならないパラメーターが一緒に使用されました。';
  } else if (error.code === 'InvalidParameterValue') {
    return '無効な値または範囲外の値が入力パラメーターに指定されました。';
  } else if (error.code === 'InvalidQueryParameter') {
    return 'AWSクエリ文字列の形式が正しくないか、AWS標準に準拠していません。';
  } else if (error.code === 'MalformedQueryString') {
    return 'クエリ文字列に構文エラーが含まれています。';
  } else if (error.code === 'MissingAction') {
    return 'リクエストにアクションまたは必須パラメータがありません。';
  } else if (error.code === 'MissingAuthenticationToken') {
    return 'リクエストには、有効な（登録済みの）AWSアクセスキーIDまたはX.509証明書のいずれかが含まれている必要があります。';
  } else if (error.code === 'MissingParameter') {
    return '指定されたアクションに必要なパラメーターが指定されていません。';
  } else if (error.code === 'NotAuthorized') {
    return 'このアクションを実行する権限がありません。';
  } else if (error.code === 'NotAuthorizedGroup') {
    return 'グローバルアドミンでログインする権限が不足しています。';
  } else if (error.code === 'OptInRequired') {
    return 'AWSアクセスキーIDには、サービスのサブスクリプションが必要です。';
  } else if (error.code === 'RequestExpired') {
    return 'リクエストの日付スタンプから15分以上後、またはリクエストの有効期限（事前署名されたURLなど）から15分以上後にリクエストがサービスに到達したか、リクエストの日付スタンプが15分を超えている未来。';
  } else if (error.code === 'ServiceUnavailable') {
    return 'サーバーの一時的な障害のため、要求は失敗しました。';
  } else if (error.code === 'ThrottlingException') {
    return 'リクエストの調整が原因で、リクエストは拒否されました。';
  } else if (error.code === 'ValidationError') {
    return '入力は、AWSサービスによって指定された制約を満たしていません。';
  } else if (error.code === 'CodeDeliveryFailureException') {
    return '認証コードの送信に失敗しました。再度お試しください。';
  } else if (error.code === 'InvalidEmailRoleAccessPolicyException') {
    return 'メールアドレスの形式が正しくありません。';
  } else if (error.code === 'InvalidSmsRoleAccessPolicyException') {
    return '認証コードを送信する権利がありません。';
  } else if (error.code === 'InvalidSmsRoleTrustRelationException') {
    return '権限が不足しています。';
  } else if (error.code === 'InvalidParameterException') {
    return 'パラメーターが不足しています。';
  } else if (error.code === 'InvalidPasswordException') {
    return 'パスワード要件を満たしていません。';
  } else if (error.code === 'CodeMismatchException') {
    return '認証コードが違います。';
  } else if (error.code === 'ExpiredCodeException') {
    //ここで再度認証コードを送信する？
    return '認証コードの有効期限が切れています。';
  } else if (
    error.code === 'InternalErrorException' ||
    error.code === 'InvalidLambdaResponseException' ||
    error.code === 'UnexpectedLambdaException' ||
    error.code === 'ResourceNotFoundException'
  ) {
    return `システムエラーが発生しました。${error.code}`;
  } else if (error.code === 'invitationExpiredException') {
    return '送信された招待はすでに完了している可能性があります。';
  } else if (error.code === 'invitationURLQueryException') {
    return '招待 URL が正しくありません。招待メールを再度ご確認ください。';
  } else if (error.code) {
    return `エラーが発生しました。${error.code}`;
  } else {
    return 'エラーが発生しました。';
  }
}
